import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Text } from '@feathr/components';
import { formatImportCount, hasRunFinished } from '@feathr/extender/components/ImportRunLines';

interface IBlankRowsLineProps {
  importer: Importer;
}

/** How many empty rows the run dropped. */
function BlankRowsLine({ importer }: Readonly<IBlankRowsLineProps>): JSX.Element | null {
  const { t } = useTranslation();

  const count = importer.get('blank', 0);
  if (!hasRunFinished(importer) || count <= 0) {
    return null;
  }

  // Placeholder copy, pending Product and Design.
  return (
    <Text.DefaultRegular>
      {t('{{formattedCount}} blank rows removed.', {
        count,
        formattedCount: formatImportCount(count),
      })}
    </Text.DefaultRegular>
  );
}

export default observer(BlankRowsLine);
